module.exports = __webpack_public_path__ + "img/Catalonia.34a2cdf8.svg";